import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'none_above_facility_meeting_measures_listed_above_regarding_9'

export const dataPointDefinition = {
  retracedId: 'none_above_facility_meeting_measures_listed_above_regarding_9',
  name: 'None of the above - the facility is meeting all measures listed above regarding safe storage of chemicals and hazardous ',
  description:
    'Select "X" if the facility HAS all the safety measures for storage of chemicals and hazardous substances described above.',
  meta: {
    slcpMeta: {
      key: 'hs-che-28x',
      number: 'HS-CHE-11-7',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-che-21',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-26,Yes- including hazardous substances;Yes- not including hazardous substances',
      machineShowHide: '[2],hs-26,1;2',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-che-28x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30190,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
